module.exports = {
  eventCategory: 'Editor UI | Tool Menu | templates',

  show: { eventAction: 'show' },

  listContentToggleEvent: function (event) {
    var $button = $(event.currentTarget);
    var $container = $button.closest('dt');

    $container.hasClass('active') || this.trackEvent({
      eventAction: 'content_toggle',
      eventLabel: $button.data('key')
    });
  }
};
